<template>
  <div class="product">
    <banner img="../assets/img/bgtop.jpg" title="产品中心" />
    <div class="product-content" v-loading="loading">
      <div class="p-video">
        <!-- <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player> -->
        <video-with-cover
          video-src="https://sxyy-001.oss-cn-beijing.aliyuncs.com/Video/PublicityVideo.mp4"
          video-cover="https://app.shanxinyy.com/minio/homepage/xxd2.jpg"
        />
      </div>
      <div class="lacking">
        <h3 class="title">善信智慧医养平台构成</h3>
        <div class="lacking-bottom">
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/PlatformComposition_Data.png" alt />
            </div>
            <p>数据管理中心</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/PlatformComposition_Old.png" alt />
            </div>
            <p>养老服务应用</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/PlatformComposition_Phone.png" alt />
            </div>
            <p>呼叫中心</p>
          </div>
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/PlatformComposition_Zhongduan.png" alt />
            </div>
            <p>智能终端接入</p>
          </div>
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/PlatformComposition_App.png" alt />
            </div>
            <p>手机端应用</p>
          </div>
        </div>
      </div>
      <!-- 平台目标 -->
      <div class="target">
        <h3 class="title">平台特征</h3>
        <p class="eTitle">TARGET</p>
        <div class="target-img">
          <img src="../assets/img/PlatformFeature.jpg" alt />
        </div>
      </div>
      <!--功能模块  -->
      <div class="modular">
        <h3 class="title">功能模块</h3>
        <p class="eTitle">MODULAR</p>
        <div class="modular-content">
          <div class="modular-content-same">
            <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/Old_Mall.png" alt />
              </div>
              <p>老年商城</p>
            </div>
            <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/Old_FuWu.png" alt />
              </div>
              <p>老年服务</p>
            </div>
            <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/OldSocialInteraction.png" alt />
              </div>
              <p>老年社交</p>
            </div>
            <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/OldDiningRoom.png" alt />
              </div>
              <p>老年餐厅</p>
            </div>
          </div>
          <div class="modular-content-center">
            <img src="../assets/img/FunctionModule.jpg" alt />
          </div>
          <div class="modular-content-same">
            <div class="same-item">
              <p>健康管理</p>
              <div class="same-item-img">
                <img src="../assets/img/HealthManagement.png" alt />
              </div>
            </div>
            <div class="same-item">
              <p>亲情互动</p>
              <div class="same-item-img">
                <img src="../assets/img/FamilyInteraction.png" alt />
              </div>
            </div>
            <div class="same-item">
              <p>紧急救助</p>
              <div class="same-item-img">
                <img src="../assets/img/SOS.png" alt />
              </div>
            </div>
            <div class="same-item">
              <p>家庭医生</p>
              <div class="same-item-img">
                <img src="../assets/img/Doctor.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="watch target">
        <h3 class="title">智能手表</h3>
        <p class="eTitle">WATCH</p>
        <div class="target-img">
          <img
            src="../assets/webImg/智能健康养老设备项目商业计划书_08.png"
            alt
          />
        </div>
      </div>
      <div class="watch BED" style="margin-top: 30px">
        <h3 class="title">智能病床</h3>
        <p class="eTitle">BED</p>
        <div class="target-img">
          <img
            src="../assets/webImg/智能健康养老设备项目商业计划书_09.png"
            alt
          />
        </div>
      </div>
      <div class="watch BED" style="margin-top: 30px">
        <h3 class="title">智能老人移位机</h3>
        <p class="eTitle">Positioning machine</p>
        <div class="target-img">
          <img
            src="../assets/webImg/智能健康养老设备项目商业计划书_10.png"
            alt
          />
        </div>
      </div>
      <div class="watch BED" style="margin-top: 30px">
        <h3 class="title">健康检测一体机</h3>
        <p class="eTitle">HEALTH AIO</p>
        <div class="target-img">
          <img
            src="../assets/webImg/智能健康养老设备项目商业计划书_11.png"
            alt
          />
        </div>
      </div>
      <div class="watch BED" style="margin-top: 30px">
        <h3 class="title">智能陪伴机器人</h3>
        <p class="eTitle">ROBOT</p>
        <div class="target-img">
          <img
            src="../assets/webImg/智能健康养老设备项目商业计划书_12.png"
            alt
          />
        </div>
      </div>
      <div class="watch BED" style="margin-top: 30px">
        <h3 class="title">适老化改造</h3>
        <p class="eTitle">Aging-friendly renovation</p>
        <div class="target-img">
          <img
            src="../assets/webImg/智能健康养老设备项目商业计划书_13.png"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import VideoWithCover from "../components/VideoWithCover.vue";
export default {
  components: {
    Banner,
    VideoWithCover,
  },

  data() {
    return {
      loading: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "https://sxyy-001.oss-cn-beijing.aliyuncs.com/Video/PublicityVideo.mp4", //url地址
          },
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },

  created() {},
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
.product {
  width: 100%;
  height: 100%;
  background-color: rgb(255, 118, 64, 0.9);
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.p-video {
  width: 1000px;
  margin: 0 auto;
  padding: 60px 0;
}

//传统管理模式不足
.lacking {
  height: 420px;
  padding: 20px 0;
  //margin: 20px 0;

  .lacking-bottom {
    display: flex;
    justify-content: space-around;
    padding: 100px 100px;

    .lacking-bottom-item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      //justify-content: center;

      .lacking-bottom-item-img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    p {
      font-size: 16px;
      text-align: start;
      margin: 10px 0;
      font-weight: bold;
    }
  }
}

//平台目标
.target {
  /* margin-top: 20px; */
  box-sizing: border-box;
  padding: 0 30px;
  &-img {
    margin-top: 50px;
    width: 100%;
    height: 100%;
  }
}

//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .same-item-img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
    p {
      color: #1667a0;
      font-weight: 700;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
}
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}

.eTitle {
  font-size: 14px;
  color: #999999;
  padding: 10px 0;
}
</style>
